// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"index_dropdown_3fgev","icon":"index_icon_2JXEQ"};